var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoboxInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 15C44.12 15 15 44.12 15 80s29.12 65 65 65 65-29.12 65-65S115.88 15 80 15zm0 10c30.36 0 55 24.64 55 55s-24.64 55-55 55-55-24.64-55-55 24.64-55 55-55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.373 18.231a9.3834 9.1153 0 1 1-18.767 0 9.3834 9.1153 0 1 1 18.767 0z",
    transform: "matrix(1.1989 0 0 1.2342 21.214 28.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.665 110.96c-.069 2.73 1.211 3.5 4.327 3.82l5.008.1v5.12H60.927v-5.12l5.503-.1c3.291-.1 4.082-1.38 4.327-3.82V80.147c.035-4.879-6.296-4.113-10.757-3.968v-5.074l30.665-1.105"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoboxInfoIcon);
export default __webpack_public_path__ + "static/media/Infobox_info_icon.c8011ff6ff64a133d8783ad315b0ea11.svg";
export { ForwardRef as ReactComponent };